import React, { useEffect, useState } from 'react'
import { ChevronDown } from 'react-feather'
import {
  convertUTCTimeToLocal,
  hexToDecimal,
  splitIntoTwo,
} from '../../../utility/Utils'

import DataTable from 'react-data-table-component'

function AlarmTable({ alarmData, header = false }) {
  const [alarmNewData, setAlarmNewData] = useState([])

  useEffect(() => {
    const tempNewData = alarmData.map((item) => {
      const alarmCode = splitIntoTwo(item.alarm_code)
      let alarmType, alarmDetail, alarmStatus, color

      switch (alarmCode[0]) {
        case '04':
          //fuse blown
          alarmType = 'Fuse Blown'
          alarmDetail =
            alarmCode[2] === '00'
              ? `Group ${hexToDecimal(alarmCode[1], 1)}, Fuse Blown is Repaired`
              : alarmCode[2] === '01'
              ? `Green Lamp Fuse Blown of Group ${hexToDecimal(
                  alarmCode[1],
                  1
                )}`
              : alarmCode[2] === '02'
              ? `Amber Lamp Fuse Blown of Group ${hexToDecimal(
                  alarmCode[1],
                  1
                )}`
              : `Red Lamp Fuse Blown of Group ${hexToDecimal(alarmCode[1], 1)}`
          alarmStatus = alarmCode[2] === '00' ? 'Fault OK' : 'Fault Detected'
          color = 'red'
          break

        case '06':
          //loop fail
          alarmType = 'Detector Failed'
          alarmDetail = `Detector Channel ${hexToDecimal(alarmCode[1], 1)} ${
            alarmCode[2] === '00' ? 'is Repaired' : 'is Failed'
          }`
          alarmStatus = alarmCode[2] === '00' ? 'Fault OK' : 'Fault Detected'
          color = 'coral'
          break

        case '08':
          //amber flash
          alarmType = 'Flashing'
          alarmDetail =
            alarmCode[1] === '00'
              ? 'XIM is restored from Flashing'
              : alarmCode[2] === '01'
              ? 'Forced Flashing'
              : alarmCode[2] === '02'
              ? 'Flashing At Night'
              : alarmCode[2] === '03'
              ? 'Flashing Triggered by Fault'
              : 'Flashing Triggered by Communication Fail'
          alarmStatus = alarmCode[1] === '01' ? 'Started' : 'End'
          color = 'yellow'
          break

        case '09':
          //double lamp
          const lamp1 =
            alarmCode[2] === '01'
              ? ' Green'
              : alarmCode[2] === '02'
              ? ' Amber'
              : ' Red'
          const lamp2 =
            alarmCode[3] === '01'
              ? ' Green'
              : alarmCode[0] === '02'
              ? ' Amber'
              : ' Red'
          alarmType = 'Double Lamp'
          alarmDetail = `Group ${hexToDecimal(
            alarmCode[1],
            1
          )},${lamp1}-${lamp2} Conflict Detected`
          alarmStatus = 'Fault Detected'
          color = 'cyan'
          break

        case '0A':
          //green conflict
          const lamp3 =
            alarmCode[2] === '01'
              ? ' Green'
              : alarmCode[2] === '02'
              ? ' Amber'
              : ' Red'
          alarmType = 'Green Conflict'
          alarmDetail = `Group ${hexToDecimal(
            alarmCode[1],
            1
          )}, Green-${lamp3} Conflict Detected`
          alarmStatus = 'Fault Detected'
          color = 'green'
          break

        case '0E':
          //TNB
          alarmType = 'TNB'
          alarmDetail =
            alarmCode[1] === '00'
              ? 'TNB supply has restored'
              : 'TNB supply has failed'
          alarmStatus = alarmCode[1] === '01' ? 'TNB FAIL' : 'TNB RESTORED'
          color = 'red'
          break

        case '0F':
          //ELCB
          alarmType = 'ELCB'
          alarmDetail =
            alarmCode[1] === '00' ? 'ELCB has reset' : 'ELCB has tripped'
          alarmStatus = alarmCode[1] === '01' ? 'ELCB TRIP' : 'ELCB RESET'
          color = 'red'
          break
        case '0B':
          //Junction Setting Update
          alarmType = 'Setting Update'
          alarmDetail =
            alarmCode[1] === '01'
              ? 'Junction Setting Updated from Desktop Programmer'
              : alarmCode[1] === '02'
              ? 'Junction Setting Updated from XAITS'
              : 'Junction Setting Updated from Android Programmer'
          alarmStatus = 'SUCCESS'
          color = 'green'
          break
      }

      return {
        ...item,
        alarmType,
        alarmDetail,
        alarmStatus,
        color,
      }
    })

    setAlarmNewData(tempNewData)
  }, [alarmData])

  let columns = []

  if (header) {
    columns = [
      ...columns,

      {
        name: 'Alarm Type',
        selector: (row) => row.alarmType,
        width: '30%',
      },
      {
        name: 'Alarm Detail',
        selector: (row) => row.alarmDetail,
        width: '70%',
      },
    ]
  } else {
    columns = [
      ...columns,
      {
        name: 'Date',
        sortable: true,
        sortField: 'date',
        selector: (row) => row.date,
        width: '10%',
      },
      {
        name: 'Time',
        sortable: true,
        sortField: 'date_time',
        selector: (row) => convertUTCTimeToLocal(row.date_time),
        width: '10%',
      },
      {
        name: 'Alarm Type',
        sortable: true,
        sortField: 'alarmType',
        selector: (row) => row.alarmType,
        width: '15%',
      },
      {
        name: 'Alarm Detail',
        sortable: true,
        sortField: 'alarmDetail',
        selector: (row) => row.alarmDetail,
        width: '35%',
      },
      {
        name: 'Status',
        sortable: true,
        sortField: 'alarmStatus',
        selector: (row) => row.alarmStatus,
        width: '15%',
      },
      {
        name: 'Acknowledgement',
        sortable: true,
        sortField: 'is_read',
        cell: (row) => (
          <div>{row.is_read === '0' ? 'Not Acknowledged' : 'Acknowledged'}</div>
        ),
        width: '15%',
      },
    ]
  }

  return (
    <>
      <div className='react-dataTable roles-table'>
        <DataTable
          noHeader
          responsive
          columns={columns}
          data={alarmNewData}
          sortIcon={<ChevronDown />}
          className='react-dataTable'
        />
      </div>
    </>
  )
}

export default AlarmTable
